module.exports = __webpack_public_path__ + "media/images/carter_bg-1fadaacf87b15e3dc19163d4747e528c.jpg";